export default {
  setInitialState({ commit }, edroneContext) {
    const params = new URLSearchParams(window.location.search);
    if (window.location.search && params.hasTag?.("lang")) {
      edroneContext.user.lang = params.get("lang");
    }

    commit("state", edroneContext);
  },
  showLoadingOverlay({ commit }) {
    commit("setLoadingOverlay", true);
  },
  hideLoadingOverlay({ commit }, payload) {
    const timeout = payload ? payload.timeout : 0;
    setTimeout(() => {
      commit("setLoadingOverlay", false);
    }, timeout);
  },
  setMenuPinned({ commit }, pinned) {
    commit("setMenuPinned", pinned);
  },
  setIsMobile({ commit }, isMobile) {
    commit("setIsMobile", isMobile);
  },
};
